import { collection, getDocs, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../../../../firebase";
import AdminButton from "../../../core/admin/adminButton";
import AdminCard from "../../../core/admin/adminCard";
import AdminEmptyState from "../../../core/admin/adminEmptyState";
import { ImageIcon, PencilIcon } from "../../../../img/svg/adminIcons";
import HeaderConfigModal from "./headerConfigModal";

export default function HeaderHome() {

    const [current, setCurrent] = useState("");
    const [configModal, setConfigModal] = useState(false);

    useEffect(() => {
        getCurrentImage();
    }, [configModal])

    const getCurrentImage = async () => {
        try {
            const q = query(collection(db, "headerimages"), where("display", "==", true));
            const docsSnap = await getDocs(q);
            if (docsSnap.empty) {
                // sem imagem ativa: limpa a prévia (antes ficava a última imagem ativa na tela)
                setCurrent("");
                return null;
            }
            setCurrent(docsSnap.docs[0].data().url);
        } catch (error) {
            console.log(error);
            return null;
        }
    }


    return (
        <>
            <AdminCard
                title="Imagem do Header"
                description="Imagem de fundo do topo da página inicial. Apenas uma pode ficar ativa."
                actions={<AdminButton variant="secondary" icon={<PencilIcon width="14px" />} onClick={() => setConfigModal(true)}>Configurar</AdminButton>}
            >
                {
                    current ?
                        <div className="relative overflow-hidden rounded-xl">
                            <img src={current} alt="current" className="h-[120px] md:h-[160px] w-full object-cover" />
                            <div className="absolute top-0 bg-gradient-to-r from-[#00000077] via-[#000000ee] to-[#00000077] w-full h-full"></div>
                            <span className="absolute bottom-3 left-3 rounded-full bg-white/90 px-2.5 py-0.5 text-xs font-bold text-gray-900">Prévia com o degradê do site</span>
                        </div>
                        :
                        <AdminEmptyState icon={<ImageIcon />} title="Nenhuma imagem configurada" />
                }
            </AdminCard>
            {
                configModal ?
                    <HeaderConfigModal close={() => setConfigModal(false)} />
                    : null
            }
        </>
    )
}
